import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    (function (responsiveLineType) {
        if (!responsiveLineType) {
            return;
        }
        var _createRowStake = responsiveLineType.createRowStake;
        $.extend(responsiveLineType, {
            createRowStake(selection, mode, context) {
                return mode.toShowStakeBox(selection)
                    ? _createRowStake.apply(this, arguments)
                    : "";
            }
        });
    })(window.TResponsiveLineType);
});
//# sourceMappingURL=TResponsiveLineType.js.map